import React from 'react';

class Spotmentor extends React.Component {
  render() {
    const {
      styles: s,
    } = this.props;
    
    return (
      <div className={s.spotmentor}>
        <h1>
          <em>S</em>
          <em>P</em>
          <em className={s.planetLeft}>O</em>
          <em>T</em>
          <em>M</em>
          <em>E</em>
          <em>N</em>
          <em>T</em>
          <em className={s.planetRight}>O</em>
          <em>R</em>
        </h1>
      </div>
      
    );
  }
}

export default Spotmentor;



// WEBPACK FOOTER //
// ./src/components/Placeholder/Spotmentor.js